<div  id="terms-container"  class="grid-container">
  <div class="grid-x">
    <div class="finalize-request">
      <fa-icon [icon]="'exclamation-triangle'" class="iana-icons align-center"></fa-icon>
      <div style="padding-left: 16px;">

        <div class="grid-x">
          <div class="content-header">A note about our terms of service</div>
          <p>
            We have updated our electronic terms of service to provide greater transparency and align with laws application to us.
            <a style="white-space: nowrap" href="https://www.icann.org/privacy/tos"
               target="_blank">Learn more</a>.

            This site uses cookies to deliver an efficient user experience and help us to see how the site is used. <a style="white-space: nowrap" href="https://www.icann.org/privacy" target="_blank">Learn more.</a>
          </p>
        </div>
      </div>
    </div>
    <div class="close-action">
      <button class="iana-button-empty-bg" (click)="close()">OK</button>
    </div>
  </div>
</div>
